import {
  Box,
  Card,
  CardActionArea,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { useMemo } from "react";
import InternFont from "./InternFont";
import { Font } from "./types";

type InternBrandStyleTypographyItemProps = {
  index?: number;
  font: Font;
  selectable?: boolean;
  isSelected?: boolean;
  onClick?: () => void;
  size?: "small" | "large";
  selectionOrder?: number; // 0 = header, 1 = body, undefined = not selected
};

const InternBrandStyleTypographyItem = ({
  index,
  font,
  selectable = false,
  isSelected = false,
  onClick,
  size = "small",
  selectionOrder,
}: InternBrandStyleTypographyItemProps) => {
  const theme = useTheme();

  const selectionLabel = useMemo(() => {
    if (selectionOrder === 0) return "Header";
    if (selectionOrder === 1) return "Body";
    return undefined;
  }, [selectionOrder]);

  const content = (
    <Box sx={{ position: "relative", width: "100%" }}>
      <InternFont font={font} />
      {selectionLabel && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            backgroundColor: theme.palette.primary.main,
            color: "white",
            borderRadius: "4px",
            px: 1,
            py: 0.5,
            zIndex: 1,
            opacity: 0.5,
          }}
        >
          <Typography
            variant="caption"
            sx={{
              fontWeight: 600,
              fontSize: "8px",
              lineHeight: 1,
            }}
          >
            {selectionLabel}
          </Typography>
        </Box>
      )}
    </Box>
  );

  if (!selectable) {
    return (
      <Card
        sx={{
          p: size === "large" ? 3 : 2,
          backgroundColor: "white",
          border: "1px solid #E0E0E0",
          borderRadius: "12px",
          minHeight: size === "large" ? "200px" : "auto",
        }}
      >
        {content}
      </Card>
    );
  }

  return (
    <Card
      sx={{
        mb: 2,
        border: isSelected
          ? `2px solid ${theme.palette.primary.main}`
          : "1px solid #E0E0E0",
        borderRadius: "8px",
        backgroundColor: isSelected ? "#F8F9FF" : "white",
        transition: "all 0.2s ease",
        "&:hover": {
          borderColor: theme.palette.primary.main,
          backgroundColor: "#F8F9FF",
        },
      }}
    >
      <Stack direction="row" alignItems="center">
        {index !== undefined && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: theme.palette.primary.main,
              color: "white",
              fontSize: "12px",
              fontWeight: 600,
              marginLeft: 2,
              marginRight: 1,
              flexShrink: 0,
            }}
          >
            {index + 1}
          </Box>
        )}
        <CardActionArea onClick={onClick} sx={{ p: 2, flex: 1 }}>
          {content}
        </CardActionArea>
      </Stack>
    </Card>
  );
};

export default InternBrandStyleTypographyItem;
